<i18n>
{
  "no": {
    "CHOOSE_CONTACT": "Velg kontaktpunkt",
    "REQUEST_PW": "Be om nytt passord"
  },
  "en": {
    "CHOOSE_CONTACT": "Choose point of contact",
    "REQUEST_PW": "Request new password"
  }
}
</i18n>

<template>
  <form method="post" @submit.prevent="onSubmit">
    <TnTextField
      v-model="username"
      name="username"
      required
      :label="t('fields.username')"
      :placeholder="t('fields.username')"
    />

    <TnButton type="submit" primary block class="margin-top-l" :text="t('REQUEST_PW')" />
  </form>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { TnButton, TnTextField } from '@telenornorgeinternal/telegrafen-vue3-core';

const emit = defineEmits<{ formSubmitted: [username: string] }>();

const { t } = useI18n();

const username = ref('');

function onSubmit() {
  emit('formSubmitted', username.value);
}
</script>
